import { render, staticRenderFns } from "./Cb4xModalContent.vue?vue&type=template&id=2d52d4d5"
import script from "./Cb4xModalContent.vue?vue&type=script&lang=js"
export * from "./Cb4xModalContent.vue?vue&type=script&lang=js"
import style0 from "./Cb4xModalContent.vue?vue&type=style&index=0&id=2d52d4d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports